const imageSections = document.querySelectorAll('.about-images');

imageSections.forEach(function(section) {
    section.addEventListener('click', function() {
        if (section.classList.contains('visible')) {
    	   section.classList.remove('visible');
        } else {
            section.classList.add('visible');
        }
    });
});

window.addEventListener('scroll', function(event) {
    imageSections.forEach(function(section) {
        if (inViewport(section)) {
            section.classList.add('visible');
        }
    });
}, false);